// product-media-slider.js
document.addEventListener('DOMContentLoaded', function () {
  // Initialize every product gallery instance on the page
  document.querySelectorAll('[id^="ProductMediaGallery-"]').forEach(function (gallery) {
    const mainEl = gallery.querySelector('.product-main-swiper');
    const thumbEl = gallery.querySelector('.product-thumb-swiper');
    if (!mainEl || !thumbEl) return;

    // Thumbs swiper
    const thumbSwiper = new Swiper(thumbEl, {
      spaceBetween: 10,
      slidesPerView: 1,
      freeMode: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      breakpoints: { 768: { slidesPerView: 6 } },
    });

    // Build navigation elements scoped to this gallery
    const nextBtn = gallery.querySelector('.slider-button--next');
    const prevBtn = gallery.querySelector('.slider-button--prev');
    const paginationEl = gallery.querySelector('.main-pagination');

    // Main swiper (no 'fade' effect — fade + thumbs + loop common bug)
    const mainSwiper = new Swiper(mainEl, {
      loop: true,
      speed: 600,
      spaceBetween: 0,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: paginationEl ? { el: paginationEl, clickable: true } : {},
      navigation: {
        nextEl: nextBtn || null,
        prevEl: prevBtn || null,
      },
      thumbs: { swiper: thumbSwiper },
      observer: true,
      observeParents: true,
      on: {
        init() {
          // ensure first slide videos/iframes handled on init
          handleSlideMedia(this);
        },
        slideChangeTransitionEnd() {
          handleSlideMedia(this);
        }
      }
    });

    // Helper: play/pause host videos + toggle external iframe autoplay
    function handleSlideMedia(swiperInstance) {
      const activeIndex = swiperInstance.activeIndex;
      const activeSlide = swiperInstance.slides[activeIndex];

      // Play videos in active slide
      activeSlide && activeSlide.querySelectorAll('video').forEach(v => {
        v.muted = true;
        v.play().catch(() => {});
      });

      // Pause videos in other slides
      swiperInstance.slides.forEach(slide => {
        if (slide !== activeSlide) {
          slide.querySelectorAll('video').forEach(v => v.pause());
        }
      });

      // Autoplay external iframe in active slide (append autoplay params)
      if (activeSlide) {
        const wrapper = activeSlide.querySelector('[data-iframe-src]');
        if (wrapper) {
          const iframe = wrapper.querySelector('iframe');
          if (iframe) {
            const base = wrapper.dataset.iframeSrc || iframe.src;
            // ensure we don't duplicate params
            iframe.src = base.indexOf('?') > -1
              ? base + '&autoplay=1&mute=1'
              : base + '?autoplay=1&mute=1';
          }
        }
      }

      // Stop autoplay on other iframes (remove autoplay param)
      swiperInstance.slides.forEach(slide => {
        if (slide !== activeSlide) {
          slide.querySelectorAll('iframe').forEach(frame => {
            if (!frame.src) return;
            frame.src = frame.src.replace(/([&?])autoplay=1(&?)/, function(_, p1, p2) {
              // remove param and fix joining char
              const remaining = frame.src.replace(/([&?])autoplay=1(&?)/, (a,b,c)=> (b === '?' && c ? '?' : ''));
              return remaining;
            });
          });
        }
      });
    }
  });
});
